import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "./plugins/compositionAPI";
import "./plugins/toastification";
import "./plugins/persianDatePicker";
import "./filters";
import "primeicons/primeicons.css";
import "./plugins/vueCookies";
import draggableDialog from "./plugins/draggableDialog";
import { RUNTIME_ENV } from "@/runtimeEnv";
import digitMixin from "./components/digitMixin";
import DatePicker from "@/components/DatePicker.vue";
import MoneyField from "@/components/MoneyField.vue";
import customSelect from "@/components/elements/customSelect.vue";
import selectGrid from "@/components/elements/selectGrid.vue";
import VueTheMask from "vue-the-mask";


// import '@/plugins/dataGrid/theme/dx.common.css';
// import '@/plugins/dataGrid/theme/dx.material.custom-scheme.css';

Vue.component("date-picker", DatePicker);
Vue.component("money-field", MoneyField);
Vue.use(VueTheMask);
Vue.use(draggableDialog);
Vue.component("customSelect", customSelect);
Vue.component("selectGrid", selectGrid);

Vue.mixin(digitMixin);

Vue.config.productionTip = false;

document.addEventListener("input", (e) => {
  if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
    let oldValue = e.target.value;
    let newValue = oldValue
      .replace(/[۰-۹]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 1728))
      .replace(/[٠-٩]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 1584));

    if (newValue !== oldValue) {
      e.target.value = newValue;
      e.target.dispatchEvent(new Event("input"));
    }
  }
});

// Block "+" and "-" in number inputs (browser accepts them before the digits)
const isNumberInput = (el) => el && el.tagName === "INPUT" && el.type === "number";

document.addEventListener(
  "keydown",
  (e) => {
    if (isNumberInput(e.target) && (e.key === "+" || e.key === "-")) {
      e.preventDefault();
    }
  },
  true
);

// Fallback for mobile keyboards that send key "Unidentified" on keydown
document.addEventListener(
  "beforeinput",
  (e) => {
    if (
      isNumberInput(e.target) &&
      e.inputType === "insertText" &&
      /[+-]/.test(e.data || "")
    ) {
      e.preventDefault();
    }
  },
  true
);

document.addEventListener(
  "paste",
  (e) => {
    if (!isNumberInput(e.target)) return;
    const text = e.clipboardData?.getData("text") || "";
    if (/[+-]/.test(text)) {
      e.preventDefault();
      const cleaned = text.replace(/[+-]/g, "");
      if (cleaned) document.execCommand("insertText", false, cleaned);
    }
  },
  true
);

document.addEventListener(
  "drop",
  (e) => {
    if (isNumberInput(e.target)) {
      const text = e.dataTransfer?.getData("text") || "";
      if (/[+-]/.test(text)) e.preventDefault();
    }
  },
  true
);

document.addEventListener(
  "touchend",
  (e) => {

    const item = e.target.closest(
      ".v-autocomplete .v-list-item, .v-select-list .v-list-item"
    );

    if (!item) return;
    // prevent duplicate (touch → click)
    if (item.__touched) return;
    item.__touched = true;

    setTimeout(() => {
      item.__touched = false;
    }, 300);

    // trigger click manually
    item.click();
  },
  { passive: true }
);

Vue.prototype.RUNTIME_ENV = RUNTIME_ENV;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
